import React, { useState, useEffect, useMemo, useRef } from "react";
import * as Yup from "yup";
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  Button,
  Grid,
  MenuItem,
  Select,
  InputLabel,
  TablePagination,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  Checkbox,
  Tooltip,
  Avatar,
  TextareaAutosize,
  Stack,
  Box,
  IconButton,
} from "@mui/material";
import { Formik, Form, Field } from "formik";
import jwtAuthAxios from "app/services/auth/jwtAuth";
import useJumboAuth from "@jumbo/hooks/useJumboAuth";
import ExcelFileUpload from "@jumbo/shared/ExcelUpload/ExcelUpload";
import useSwalWrapper from "@jumbo/vendors/sweetalert2/hooks";
import * as XLSX from "xlsx";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import {
  Close,
  Download,
  ModeEditOutlineRounded,
  RemoveRedEye,
} from "@mui/icons-material";
import Div from "@jumbo/shared/Div";
import { LoadingButton } from "@mui/lab";
import { Link } from "react-router-dom";
import getTransactionDetail from "app/services/globleFunction/getTransactionDetail";
import TableView from "app/shared/Tableview/Tableview";
import TableSkeleton from "app/shared/widgets/TableSkeleton";
import JumboTextField from "@jumbo/components/JumboFormik/JumboTextField";
import { BACKEND_APP_URL } from "app/utils/constants/paths";
import DiamondIcon from "@mui/icons-material/Diamond";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

const validationSchema = Yup.object().shape({
  FL_TRANS_DATE: Yup.string().required("Transaction Date is required"),
  FL_TRANS_TYPE: Yup.string().required("Transaction Type is required"),
  FL_PARTY_CODE: Yup.string().required("Party Code is required"),
  FL_TO_ACH_CODE: Yup.string().required("Bank is required"),
  FL_TERM_CODE: Yup.string().required("Term Code is required"),
  FL_SHIP_BY: Yup.string().required("Shipping By is required"),
  FL_BILL_NO: Yup.string().required("Bill No is required"),
  FL_CURR_CODE: Yup.string().required("Currency Code is required"),
  FL_CONV_RATE: Yup.number().required("Conversion Rate is required"),
  FL_DIAMOND_TYPE: Yup.string().required("Diamond Type is required"),
  FL_BUSINESS_TYPE: Yup.string().required("Business Type is required"),
  // narration: Yup.string().required('Narration is required'),
});

const rowsPerPageOptions = [10, 250, 500];

const PolishInward = () => {
  const [view, setView] = useState(null);
  const [currentType, setCurrentType] = useState(null);
  const [Data, setData] = useState(null);
  const [initialValues, setInitialValues] = useState({
    FL_TRANS_DATE: "",
    FL_TRANS_TYPE: "",
    FL_TO_ACH_CODE: "",
    FL_PARTY_CODE: "",
    FL_TERM_CODE: "",
    FL_SHIP_BY: "",
    FL_CURR_CODE: "",
    FL_CONV_RATE: "",
    FL_BILL_NO: "",
    FL_DIAMOND_TYPE: "",
    FL_BUSINESS_TYPE: "",
    is_p: false,
    FL_BROKER_PER: "",
    FL_ADAT_FLG: "",
    FL_NARRATION: "",
    FL_BROKER_PARTY: "",
  });

  let fetchINtrData = async ()=>{
    let data =await getTransactionDetail(`type=INWARD`).then(res =>{
      // console.log(res);
          setData(res)
          setCurrentType('INWARD')
          })
  }
 
  useEffect(async () => {
    fetchINtrData();
    //setCurrentType("DETAIL")
  }, []);
  const handleDetailView = async (e) => {
    setData(null);
    await jwtAuthAxios
      .post("transation/transactionDetails", { P_NO: e.TR, P_TYPE: e.TYPEID })
      .then((res) => {
        setData(res.data.data);
        setCurrentType("DETAIL");
      })
      .catch(() => {
        alert("internal server error");
        setCurrentType("INWARD");
      });
    // let Data = await getTransactionDetail(`pid=${e.ID}`)
    // setData(Data)
  };
  const inwardEditHandler = async (e) => {
    setData(null);
    await jwtAuthAxios
      .post("transation/transactionDetailsforupdate", {
        trno: e.TR,
        trtype: e.TYPEID,
      })
      .then((res) => {
        // console.log(res.data.data);
        setInitialValues({
          ...initialValues,
          FL_TRANS_NO: res?.data?.data?.mas?.FL_TRANS_NO,
          FL_TRANS_DATE: res?.data?.data?.mas?.FL_TRANS_DATE?.split("T")[0],
          FL_TRANS_TYPE: res?.data?.data?.mas?.FL_TRANS_TYPE,
          FL_PARTY_CODE: res?.data?.data?.mas?.FL_PARTY_CODE,
          FL_TO_ACH_CODE: res?.data?.data?.mas?.FL_TO_ACH_CODE,
          FL_TERM_CODE: res?.data?.data?.mas?.FL_TERM_CODE,
          FL_SHIP_BY: res?.data?.data?.mas?.FL_SHIP_BY,
          FL_CURR_CODE: res?.data?.data?.mas?.FL_CURR_CODE,
          FL_CONV_RATE: res?.data?.data?.mas?.FL_CONV_RATE,
          FL_BILL_NO: res?.data?.data?.mas?.FL_BILL_NO,
          FL_DIAMOND_TYPE: res?.data?.data?.mas?.FL_DIAMOND_TYPE,
          FL_BUSINESS_TYPE: res?.data?.data?.mas?.FL_BUSINESS_TYPE,
          FL_BROKER_PER: res?.data?.data?.mas?.FL_BROKER_PER,
          FL_ADAT_FLG: res?.data?.data?.mas?.FL_ADAT_FLG,
          FL_NARRATION: res?.data?.data?.mas?.FL_NARRATION,
          FL_BROKER_PARTY: res?.data?.data?.mas?.FL_BROKER_PARTY || "",
          detlist: res?.data?.data?.det,
        });
        setView("bulkupload");
      })
      .catch(() => {
        alert("internal server error");
        setCurrentType("INWARD");
      });
    if (e.ID) {
      let Data = await getTransactionDetail(`pid=${e.ID}`);
      setData(Data);
    }
  };

  return (
    <>
      <Grid
        container
        alignItems={"center"}
        sx={{ mb: 2 }}
        justifyContent={"space-between"}
      >
        {currentType == "DETAIL" ? (
          <Typography
            variant="h1"
            sx={{ cursor: "pointer" }}
            onClick={() => {
              setCurrentType("INWARD");
              fetchINtrData();
            }}
          >
            {"<"} Back To Main{" "}
          </Typography>
        ) : (
          <Typography variant="h1">Polish Inward</Typography>
        )}
        <Button
          variant="contained"
          onClick={() => {
            setView("bulkupload");
          }}
          color="primary"
        >
          Inward
        </Button>
      </Grid>
      {view == "bulkupload" ? (
        <BulkPolishInward
          initialValues={initialValues}
          setInitialValues={setInitialValues}
          setCurrentType={setCurrentType}
          fetchINtrData={fetchINtrData}
          setView={setView}
        />
      ) : Data != null ? (
        <TableView
          body={Data}
          actions={
            currentType == "INWARD"
              ? (row) => (
                  <div>
                    <Button onClick={() => handleDetailView(row)}>
                      <RemoveRedEye />
                    </Button>
                    <Button onClick={() => inwardEditHandler(row)}>
                      <ModeEditOutlineRounded />
                    </Button>
                    {/* <button >Edit</button>
          <button onClick={() => handleDelete(row)}>Delete</button> */}
                  </div>
                )
              : false
          }
        />
      ) : (
        <TableSkeleton cols={15} />
      )}
    </>
  );
};

// const columns = [
// { field: 'FL_PREFIX', width:50, headerName: 'Prefix' ,editable:true},
// { field: 'FL_STONE_ID', width:100, headerName: 'Stone No' ,editable:true},
// { field: 'FL_LAB', width:80, headerName: 'Lab' ,editable:true},
// { field: 'FL_CERTIFICATENO', width:120, headerName: 'Report No' ,editable:true},
// { field: 'FL_SHAPE', width:100, headerName: 'Shape' ,editable:true},
// { field: 'FL_WGT', width:80, headerName: 'Carats' ,editable:true},
// { field: 'FL_COLOR', width:80, headerName: 'Color' ,editable:true},
// { field: 'FL_CLARITY', width:80, headerName: 'Clarity' ,editable:true},
// { field: 'FL_CUT', width:80, headerName: 'Cut' ,editable:true},
// { field: 'FL_POLISH', width:80, headerName: 'Polish' ,editable:true},
// { field: 'FL_SYM', width:80, headerName: 'Symm' ,editable:true},
// { field: 'FL_MEASUREMENTS', width:150, headerName: 'Measurements' ,editable:true},
// { field: 'FL_TABLE_PER', width:80, headerName: 'Table %' ,editable:true},
// { field: 'FL_DEPTH_PER', width:80, headerName: 'Depth %' ,editable:true},
// { field: 'FL_RATIO', width:50, headerName: 'Ratio' ,editable:true},
// { field: 'FL_RAP_PRICE_US', width:80, headerName: 'Rap. Price' ,editable:true},
// { field: 'FL_INTERNALCOMMENT', width:80, headerName: 'Comments 1' ,editable:true},
// { field: 'FL_LUSTER', width:80, headerName: 'Luster' ,editable:true},
// { field: 'FL_SHADE', width:80, headerName: 'Shade' ,editable:true},
// { field: 'FL_TABLEINCLUSION', width:80, headerName: 'Table Incl' ,editable:true},
// { field: 'FL_SIDEINCLUSION', width:80, headerName: 'Side Incl' ,editable:true},
// { field: 'FL_TABLEBLACK', width:80, headerName: 'Table Black' ,editable:true},
// { field: 'FL_SIDEBLACK', width:80, headerName: 'Side Black' ,editable:true},
// { field: 'FL_TABLEOPEN', width:80, headerName: 'Table Open' ,editable:true},
// { field: 'FL_CROWNOPEN', width:80, headerName: 'Crown Open' ,editable:true},
// { field: 'FL_PAVILIONOPEN', width:80, headerName: 'Pav.Open' ,editable:true},
// { field: 'FL_EXTRAFACET', width:80, headerName: 'Extra Facet' ,editable:true},
// { field: 'FL_GIRDLE_PER', width:80, headerName: 'Girdle Per' ,editable:true},
// { field: 'FL_GIRDLE', width:150, headerName: 'Girdle' ,editable:true},
// { field: 'FL_CULET', width:80, headerName: 'Culet' ,editable:true},
// { field: 'FL_CROWNHANGLE', width:80, headerName: 'Crown Angle' ,editable:true},
// { field: 'FL_CROWNHEIGHT', width:80, headerName: 'Crown Height' ,editable:true},
// { field: 'FL_PAVILIONANGLE', width:80, headerName: 'Pav Angle' ,editable:true},
// { field: 'FL_PAVILIONHEIGHT', width:80, headerName: 'Pav Height' ,editable:true},
// { field: 'FL_KEYTOSYMBOL', width:80, headerName: 'Key To Symbols' ,editable:true},
// { field: 'FL_INCRIPTION', width:80, headerName: 'Inscription' ,editable:true},
// { field: 'FL_VIDEO_LINK', width:80, headerName: 'Video Link' ,editable:true},
// { field: 'FL_COSTDISC', width:80, headerName: 'Discount' ,editable:true},
// { field: 'FL_COSTRATE', width:80, headerName: 'RatePerCarat' ,editable:true},
// { field: 'FL_COSTAMT', width:80, headerName: 'Amount' ,editable:true},
// { field: 'FL_MEMBERCOMMENT', width:80, headerName: 'PurchaseRemark' ,editable:true},
// { field: 'FL_HNA', width:80, headerName: 'HNA' ,editable:true},
// ]

const BulkPolishInward = ({
  initialValues,
  setCurrentType,
  fetchINtrData,
  setView,
}) => {
  const [excelfile, setExcelfile] = useState(null);
  const [excelData, setExcelData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [mdata, setmdatah] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const { authUser } = useJumboAuth();
  const [page, setPage] = useState(0);
  const [totalWeight, setTotalWeight] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [removableStone, setRemovableStone] = useState([]);
  const [updatedStone, setUpdatedStone] = useState([]);
  const [insertedStone, setInserteddStone] = useState([]);
  const [validationErrors, setValidationErrors] = useState({});
  const [tableData, setTableData] = useState(initialValues?.detlist || []);
  const swal = useSwalWrapper();

  const columnsdata = useMemo(
    () => [
      {
        accessorKey: "FL_PREFIX",
        size: 50,
        header: "Prefix",
        enableEditing: true,
      },
      {
        accessorKey: "FL_STONE_ID",
        size: 100,
        header: "Stone No",
        enableEditing: true,
      },
      { accessorKey: "FL_LAB", size: 80, header: "Lab", enableEditing: true },
      {
        accessorKey: "FL_CERTIFICATENO",
        size: 120,
        header: "Report No",
        enableEditing: true,
      },
      {
        accessorKey: "FL_SHAPE",
        size: 100,
        header: "Shape",
        enableEditing: true,
      },
      {
        accessorKey: "FL_WGT",
        size: 80,
        header: "Carats",
        enableEditing: true,
      },
      {
        accessorKey: "FL_COLOR",
        size: 80,
        header: "Color",
        enableEditing: true,
      },
      {
        accessorKey: "FL_CLARITY",
        size: 80,
        header: "Clarity",
        enableEditing: true,
      },
      { accessorKey: "FL_CUT", size: 80, header: "Cut", enableEditing: true },
      {
        accessorKey: "FL_POLISH",
        size: 80,
        header: "Polish",
        enableEditing: true,
      },
      { accessorKey: "FL_SYM", size: 80, header: "Symm", enableEditing: true },
      {
        accessorKey: "FL_MEASUREMENTS",
        size: 150,
        header: "Measurements",
        enableEditing: true,
      },
      {
        accessorKey: "FL_TABLE_PER",
        size: 80,
        header: "Table %",
        enableEditing: true,
      },
      {
        accessorKey: "FL_DEPTH_PER",
        size: 80,
        header: "Depth %",
        enableEditing: true,
      },
      {
        accessorKey: "FL_RATIO",
        size: 50,
        header: "Ratio",
        enableEditing: true,
      },
      {
        accessorKey: "FL_RAP_PRICE_US",
        size: 80,
        header: "Rap. Price",
        enableEditing: true,
      },
      {
        accessorKey: "FL_INTERNALCOMMENT",
        size: 80,
        header: "Comments 1",
        enableEditing: true,
      },
      {
        accessorKey: "FL_LUSTER",
        size: 80,
        header: "Luster",
        enableEditing: true,
      },
      {
        accessorKey: "FL_SHADE",
        size: 80,
        header: "Shade",
        enableEditing: true,
      },
      {
        accessorKey: "FL_TABLEINCLUSION",
        size: 80,
        header: "Table Incl",
        enableEditing: true,
      },
      {
        accessorKey: "FL_SIDEINCLUSION",
        size: 80,
        header: "Side Incl",
        enableEditing: true,
      },
      {
        accessorKey: "FL_TABLEBLACK",
        size: 80,
        header: "Table Black",
        enableEditing: true,
      },
      {
        accessorKey: "FL_SIDEBLACK",
        size: 80,
        header: "Side Black",
        enableEditing: true,
      },
      {
        accessorKey: "FL_TABLEOPEN",
        size: 80,
        header: "Table Open",
        enableEditing: true,
      },
      {
        accessorKey: "FL_CROWNOPEN",
        size: 80,
        header: "Crown Open",
        enableEditing: true,
      },
      {
        accessorKey: "FL_PAVILIONOPEN",
        size: 80,
        header: "Pav.Open",
        enableEditing: true,
      },
      {
        accessorKey: "FL_EXTRAFACET",
        size: 80,
        header: "Extra Facet",
        enableEditing: true,
      },
      {
        accessorKey: "FL_GIRDLE_PER",
        size: 80,
        header: "Girdle Per",
        enableEditing: true,
      },
      {
        accessorKey: "FL_GIRDLE",
        size: 150,
        header: "Girdle",
        enableEditing: true,
      },
      {
        accessorKey: "FL_CULET",
        size: 80,
        header: "Culet",
        enableEditing: true,
      },
      {
        accessorKey: "FL_CROWNHANGLE",
        size: 80,
        header: "Crown Angle",
        enableEditing: true,
      },
      {
        accessorKey: "FL_CROWNHEIGHT",
        size: 80,
        header: "Crown Height",
        enableEditing: true,
      },
      {
        accessorKey: "FL_PAVILIONANGLE",
        size: 80,
        header: "Pav Angle",
        enableEditing: true,
      },
      {
        accessorKey: "FL_PAVILIONHEIGHT",
        size: 80,
        header: "Pav Height",
        enableEditing: true,
      },
      {
        accessorKey: "FL_KEYTOSYMBOL",
        size: 80,
        header: "Key To Symbols",
        enableEditing: true,
      },
      {
        accessorKey: "FL_INCRIPTION",
        size: 80,
        header: "Inscription",
        enableEditing: true,
      },
      {
        accessorKey: "FL_VIDEO_LINK",
        size: 80,
        header: "Video Link",
        enableEditing: true,
      },
      {
        accessorKey: "FL_COSTDISC",
        size: 80,
        header: "Discount",
        enableEditing: true,
      },
      {
        accessorKey: "FL_COSTRATE",
        size: 80,
        header: "RatePerCarat",
        enableEditing: true,
      },
      {
        accessorKey: "FL_COSTAMT",
        size: 80,
        header: "Amount",
        enableEditing: true,
      },
      {
        accessorKey: "FL_MEMBERCOMMENT",
        size: 80,
        header: "PurchaseRemark",
        enableEditing: true,
      },
      { accessorKey: "FL_HNA", size: 80, header: "HNA", enableEditing: true },
      {
        accessorKey: "FL_INVENTORY_TYPE",
        size: 180,
        header: "Inventory Type",
        editSelectOptions: ["POLISH-SINGLE", "POLISH-PARCEL"],
        muiEditTextFieldProps: {
          select: true,
        },
        enableEditing: true,
      },
    ],
    []
  );
  useEffect(() => {
    // Fetch the branch data
    async function fetchMdata() {
      try {
        const { data } = await jwtAuthAxios.get(
          "master/helper?term=1&paramsData=SHIPPEDBY,OUR_BUSINESS_TYPE&Vendor=1&broker=1&curr=1&inventoryType=1&trtype=INWARD&leadgerdetail=22"
        );
        // await jwtAuthAxios.post('/acc/getleadgerdetail',{tono:[22]}).then(res=>{
        setmdatah(data.data);
        // }).catch(e=>{
        //   swal.fire({
        //     icon:"error",
        //     text:e
        //   })
        // })
      } catch (error) {
        // Handle the error
      }
    }
    fetchMdata();
  }, []);
  useEffect(() => {}, [mdata]);

  const handleFormSubmit = async (values) => {
    setCurrentType("DETAIL");
    // console.log(values); return
    if (openModal) return;
    if (excelfile == null && !values?.FL_TRANS_NO) {
      swal.fire({
        icon: "error",
        text: "Please Upload File",
      });
    } else {
      // console.log(values);
      let formData;
      if (values?.FL_TRANS_NO) {
        // formData.append('FromBranch', values.FromBranch);
        // formData.append('jangadDate', values.jangadDate);
        formData = {
          FL_ADAT_FLG: values.FL_ADAT_FLG,
          FL_BILL_NO: values.FL_BILL_NO,
          FL_BROKER_PARTY: values.FL_BROKER_PARTY,
          FL_BROKER_PER: values.FL_BROKER_PER,
          FL_BUSINESS_TYPE: values.FL_BUSINESS_TYPE,
          FL_CONV_RATE: values.FL_CONV_RATE,
          FL_TO_ACH_CODE: values.FL_TO_ACH_CODE,
          FL_CURR_CODE: values.FL_CURR_CODE,
          FL_DIAMOND_TYPE: values.FL_DIAMOND_TYPE,
          FL_PARTY_CODE: values.FL_PARTY_CODE,
          FL_SHIP_BY: values.FL_SHIP_BY,
          FL_TERM_CODE: values.FL_TERM_CODE,
          FL_TRANS_DATE: values.FL_TRANS_DATE,
          FL_TRANS_NO: values.FL_TRANS_NO,
          FL_TRANS_TYPE: values.FL_TRANS_TYPE,
          FL_NARRATION: values.FL_NARRATION,
          FL_INVENTORY_TYPE: values.FL_INVENTORY_TYPE,
          detval: tableData.filter((d) => updatedStone.includes(d.FL_STONE_ID)),
          detinseval: tableData.filter((d) =>
            insertedStone.includes(d.FL_STONE_ID)
          ),
          detvalDel: removableStone,
        };
        // formData.append('detval',tableData)
        //  formData.append('detvalDel',removableStone)
      } else {
        formData = new FormData();
        formData.append("excelfile", excelfile);
        await Object.keys(values).map((item) =>
          formData.append(item, values[item])
        );
      }
      // Object.keys(values).map(item => console.log(item, values[item]))
      setLoading(true);

      // Make the API call with the Excel data
      let url = values?.FL_TRANS_NO
        ? `transation/polishInward/edit/${values?.FL_TRANS_NO}`
        : "transation/polishInward";
      jwtAuthAxios
        .post(url, formData)
        .then((response) => {
          // console.log(response.data);
          if (response.data.status == "success") {
            swal.fire({
              icon: "success",
              text: response.data.message,
            });
          } else {
            swal.fire({
              icon: "error",
              text: response.data.message,
            });
          }
          // response.data.status == 'success' && navigate('/stock')
        })
        .catch(() => {
          swal.fire({
            icon: "error",
            text: "Internal server error",
          });
        })
        .finally(() => {
          setLoading(false);
        });
    }
    // reader.readAsBinaryString(excelfile);
    // }

    return false;
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const displayData = excelData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );
  const handleCloseModal = () => {
    setOpenModal(false); // Close the modal
  };

  const handleShowJsonData = async () => {
    if (excelfile == null) {
      swal.fire({
        icon: "error",
        text: "Please Upload File",
      });
    } else {
      // Convert Excel data to JSON
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: "binary" });
        const sheetName = workbook.SheetNames[0];
        const jsonData = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
        setExcelData(jsonData);
        setPage(0); // Reset to the first page
      };
      reader.readAsBinaryString(excelfile);
      setOpenModal(true);
      const sum = await excelData.reduce((accumulator, currentValue) => {
        return accumulator + Number(currentValue["Carats"]);
      }, 0);
      setTotalWeight(sum.toFixed(3));
    }
  };
  const columnVirtualizerInstanceRef = useRef(null);
  //DELETE action
  const openDeleteConfirmModal = (row) => {
    if (window.confirm("Are you sure you want to delete this user?")) {
      // deleteUser(row.original.id);
      setRemovableStone([...removableStone, row.id]);
      let UPDOBJ = tableData.filter((item) => item.FL_STONE_ID !== row.id);
      setTableData(UPDOBJ);
    }
  };
  const table = useMaterialReactTable({
    columnVirtualizerInstanceRef, //optional
    columnVirtualizerOptions: { overscan: 4 }, //optionally customize the virtualizer
    columns: columnsdata, //500 columns
    data: tableData,
    enableRowActions: true,
    // enableEditing: true,
    selectAllMode: true,
    createDisplayMode: "modal", //default ('row', and 'custom' are also available)
    editDisplayMode: "modal",
    showAddRow: true,
    onEditingRowSave: async (e) => {
      setUpdatedStone([...updatedStone, e.values.FL_STONE_ID]);
      let UPDOBJ = tableData.map((i) => {
        if (i.FL_STONE_ID == e.values.FL_STONE_ID) {
          return e.values;
        } else {
          return i;
        }
      });
      setTableData(UPDOBJ);
      e.exitEditingMode(true);
      // console.log(e);
    },
    onCreatingRowSave: async (e) => {
      // console.log(e);
      setInserteddStone([...insertedStone, e.values.FL_STONE_ID]);
      setTableData([
        { FL_STONE_ID: "new-" + e.values.FL_STONE_ID, ...e.values },
        ...tableData,
      ]);
      // e.exitEditingMode(true)
      table.setCreatingRow(false);
      // console.log(e);
    },
    getRowId: (row) => row.FL_STONE_ID,

    // onEditingRowChange: (rowIndexes) => console.log(rowIndexes),
    // enableColumnPinning: true,
    enableColumnResizing: true,
    renderTopToolbarCustomActions: ({ table }) => (
      <Button
        variant="contained"
        onClick={() => {
          table.setCreatingRow(true); //simplest way to open the create row modal with no default values
          //or you can pass in a row object to set default values with the `createRow` helper function
          // table.setCreatingRow(
          //   createRow(table, {
          //     //optionally pass in default values for the new row, useful for nested data or other complex scenarios
          //   }),
          // );
        }}
      >
        Add New Record
      </Button>
    ),
    renderRowActionMenuItems: ({ row, table }) =>
      row.original.STATUS == "A" && (
        <Box sx={{ display: "flex", gap: "1rem" }}>
          <Tooltip title="Edit">
            <IconButton onClick={() => table.setEditingRow(row)}>
              <EditIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Delete">
            <IconButton
              color="error"
              onClick={() => openDeleteConfirmModal(row)}
            >
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        </Box>
      ),
  });

  return (
    <div>
      <Card>
        <Typography
          variant="h1"
          sx={{ cursor: "pointer" }}
          onClick={() => {
            setView(null);
            setCurrentType("INWARD");
            fetchINtrData();
          }}
        >
          {"<"} Back To Main{" "}
        </Typography>
        <CardHeader
          title={<Typography variant="h4">Bulk Polish Inward</Typography>}
          subheader={
            <Typography sx={{ mt: 1, color: "text.secondary" }}>
              Drag & drop an Excel file here, or click to select one
            </Typography>
          }
          action={
            <Stack direction={"row"} spacing={3}>
              <Tooltip title="Jewelry Sample File">
                <Link
                  to={`${BACKEND_APP_URL}demo/green_jewel.xlsx`}
                  target="_blank"
                >
                  <Avatar>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 693 800"
                      fill="white"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M162.479 62.1786C165.143 64.8427 169.139 67.5053 173.134 67.5053C175.798 67.5053 178.461 66.174 179.793 66.174C186.453 62.1786 187.784 54.1878 183.789 47.5282L157.152 7.57403C153.157 0.914482 145.166 -0.416804 138.506 3.57862C133.18 7.57403 131.847 15.5649 135.842 22.2244L162.479 62.1786Z"
                        fill="white"
                      />
                      <path
                        d="M625.948 174.05C629.943 174.05 632.607 172.719 635.27 170.055L675.224 130.101C680.551 124.774 680.551 116.783 675.224 111.455C669.897 106.128 661.906 106.128 656.578 111.455L616.624 151.409C611.297 156.736 611.297 164.727 616.624 170.055C619.29 172.719 621.952 174.05 625.948 174.05Z"
                        fill="white"
                      />
                      <path
                        d="M49.2781 111.455C43.9514 106.128 35.9606 106.128 30.6323 111.455C25.3041 116.782 25.3056 124.773 30.6323 130.101L70.5865 170.055C73.2507 172.719 75.9132 174.05 79.9086 174.05C83.9041 174.05 86.5682 172.719 89.2308 170.055C94.5575 164.728 94.5575 156.737 89.2308 151.409L49.2781 111.455Z"
                        fill="white"
                      />
                      <path
                        d="M511.415 64.843C514.079 66.1743 516.742 67.5071 519.406 67.5071C523.401 67.5071 527.397 64.843 530.061 60.8476L556.698 20.8934C560.692 14.2338 559.36 6.24298 552.701 2.24756C546.041 -1.74786 538.05 -0.416573 534.055 6.24298L507.418 46.1972C503.424 52.8567 504.756 60.8476 511.415 64.843Z"
                        fill="white"
                      />
                      <path
                        d="M531.389 740.069C527.393 733.41 519.403 732.078 512.743 736.074C506.083 740.069 504.752 748.06 508.748 754.72L535.384 794.674C538.048 797.338 542.044 800 546.039 800C548.703 800 551.366 798.669 554.03 798.669C560.69 794.674 562.021 786.683 558.025 780.023L531.389 740.069Z"
                        fill="white"
                      />
                      <path
                        d="M57.2656 630.859L17.3114 670.813C11.9847 676.14 11.9847 684.131 17.3114 689.459C19.9756 692.123 22.6381 693.455 26.6336 693.455C30.629 693.455 33.2931 692.123 35.9557 689.459L75.9099 649.505C81.2366 644.178 81.2366 636.188 75.9099 630.859C70.5832 625.533 62.5923 625.533 57.2656 630.859Z"
                        fill="white"
                      />
                      <path
                        d="M621.953 630.859C616.627 625.533 608.636 625.533 603.308 630.859C597.981 636.186 597.981 644.177 603.308 649.505L643.262 689.459C645.926 692.123 648.588 693.455 652.584 693.455C656.579 693.455 659.243 692.123 661.906 689.459C667.233 684.133 667.233 676.142 661.906 670.813L621.953 630.859Z"
                        fill="white"
                      />
                      <path
                        d="M179.796 734.741C173.136 730.745 165.145 732.077 161.15 738.736L134.513 778.69C130.518 785.35 131.849 793.341 138.509 797.336C141.173 798.667 143.835 800 146.499 800C150.495 800 154.49 797.336 157.154 793.341L183.791 753.387C187.786 746.727 186.454 738.736 179.796 734.741Z"
                        fill="white"
                      />
                      <path
                        d="M346.267 67.5053C354.258 67.5053 359.584 62.1786 359.584 54.1878V14.2336C359.584 6.24272 354.258 0.916016 346.267 0.916016C338.276 0.916016 332.949 6.24272 332.949 14.2336V54.1878C332.949 62.1786 338.276 67.5053 346.267 67.5053Z"
                        fill="white"
                      />
                      <path
                        d="M346.267 733.409C338.276 733.409 332.949 738.736 332.949 746.727V786.681C332.949 794.672 338.276 799.998 346.267 799.998C354.258 799.998 359.584 794.672 359.584 786.681V746.727C359.586 738.736 354.258 733.409 346.267 733.409Z"
                        fill="white"
                      />
                      <path
                        d="M13.3175 333.868H53.2717C61.2626 333.868 66.5893 328.541 66.5893 320.55C66.5893 312.559 61.2626 307.232 53.2717 307.232H13.3175C5.32671 307.232 0 312.559 0 320.55C0 328.541 5.32671 333.868 13.3175 333.868Z"
                        fill="white"
                      />
                      <path
                        d="M53.2717 507.001C61.2626 507.001 66.5893 501.675 66.5893 493.684C66.5893 485.693 61.2626 480.366 53.2717 480.366H13.3175C5.32671 480.366 0 485.693 0 493.684C0 501.675 5.32671 507.001 13.3175 507.001H53.2717Z"
                        fill="white"
                      />
                      <path
                        d="M639.267 307.23C631.276 307.23 625.949 312.557 625.949 320.548C625.949 328.539 631.276 333.866 639.267 333.866H679.221C687.212 333.866 692.539 328.539 692.539 320.548C692.539 312.557 687.212 307.23 679.221 307.23H639.267Z"
                        fill="white"
                      />
                      <path
                        d="M679.221 480.366H639.267C631.276 480.366 625.949 485.693 625.949 493.684C625.949 501.675 631.276 507.001 639.267 507.001H679.221C687.212 507.001 692.539 501.675 692.539 493.684C692.539 485.693 687.212 480.366 679.221 480.366Z"
                        fill="white"
                      />
                      <path
                        d="M584.662 592.744V202.019C585.388 199.843 585.302 197.674 584.662 195.714V195.359L584.454 195.117C583.9 193.713 583.062 192.428 581.998 191.364L502.089 98.138C501.531 97.5793 500.903 97.0939 500.24 96.6522L498.094 94.1426H193.111L106.543 195.359V605.556L107.954 607.206C108.291 607.988 108.686 608.77 109.207 609.552L189.115 702.778C189.674 703.336 190.302 703.822 190.965 704.263L193.111 706.773H499.427L517.692 684.798L583.331 608.22C585.995 605.556 587.326 601.561 585.995 597.565C585.993 595.888 585.502 594.224 584.662 592.744ZM197.106 576.257L235.729 614.88L198.439 670.816L141.172 604.225L197.106 576.257ZM258.369 600.23L213.088 554.949V247.301L259.702 200.688H434.169L456.81 223.329L479.451 245.97V554.949L434.17 600.23H258.369ZM495.432 576.257L551.367 604.225L494.1 670.816L456.81 614.88L495.432 576.257ZM495.432 224.66L456.809 186.037L494.099 130.101L551.366 196.692L495.432 224.66ZM432.393 174.051H261.476L225.961 120.779H467.905L432.393 174.051ZM198.438 130.101L235.728 186.037L197.105 224.66L141.183 196.7L169.802 163.398L198.438 130.101ZM133.18 221.996L186.451 248.633V551.618L133.18 578.255V221.996ZM260.145 626.865H432.393L467.908 680.136H224.631L260.145 626.865ZM506.085 551.618V247.3L560.689 219.998V578.92L506.085 551.618Z"
                        fill="white"
                      />
                      <path
                        d="M438.165 441.744C438.165 399.126 392.884 376.486 391.551 376.486C379.565 368.495 372.906 360.504 371.574 349.849C367.579 327.208 387.556 299.24 395.547 289.918C399.542 285.923 400.873 279.263 396.878 273.936C392.883 268.61 386.223 265.945 380.896 268.61C375.57 269.941 253.043 319.219 253.043 440.413C253.043 492.353 294.328 533.639 346.269 533.639C398.211 533.639 439.498 492.353 438.165 441.744ZM346.27 507.002C308.98 507.002 279.68 477.703 279.68 440.411C279.68 379.149 318.303 339.194 350.266 316.553C346.27 327.208 343.606 340.526 346.27 353.843C350.266 372.489 360.921 387.138 380.898 399.124C380.898 399.124 412.861 415.106 412.861 440.41C412.861 477.703 383.562 507.002 346.27 507.002Z"
                        fill="white"
                      />
                    </svg>
                  </Avatar>
                </Link>
              </Tooltip>
              <Tooltip title="DownLoad Parcel Sample file">
                <Link
                  to={`${BACKEND_APP_URL}demo/INWARDDATA.xlsx`}
                  target="_blank"
                >
                  <Avatar>
                    <Download />
                  </Avatar>
                </Link>
              </Tooltip>
              <Tooltip title="DownLoad Single Sample file">
                <Link
                  to={`${BACKEND_APP_URL}demo/Single_polish_inward_list.xlsx`}
                  target="_blank"
                >
                  <Avatar>
                    <DiamondIcon />
                  </Avatar>
                </Link>
              </Tooltip>
            </Stack>
          }
        />
        <CardContent
          sx={{
            display: "flex",
            minWidth: 0,
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: (theme) => theme.palette.action.hover,
          }}
        >
          {/* {JSON.stringify(mdata)} */}
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleFormSubmit}
            // onSubmit={(e)=>e.key !== 'Enter' && handleFormSubmit(e)}
          >
            {({ isSubmitting, errors, touched, handleChange, values }) =>
              mdata != null && (
                <Form
                  onKeyDown={(e) => e.key === "Enter" && e.preventDefault()}
                  style={{ display: "block", width: "100%" }}
                >
                  <Grid container spacing={2}>
                    <Grid item xs={4}>
                      <InputLabel>Transaction Type</InputLabel>
                      <Field
                        size="small"
                        name="FL_TRANS_TYPE"
                        disabled={values?.FL_TRANS_NO}
                        InputLabel="Transaction Type"
                        as={Select}
                        fullWidth
                      >
                        <MenuItem value="">Select Transaction Type</MenuItem>
                        {mdata?.TRANSATION_TYPE.map((item) => (
                          <MenuItem value={item.FL_GPID}>
                            {item.FL_PARA_VALUE}
                          </MenuItem>
                        ))}
                      </Field>
                      {errors.FL_TRANS_TYPE && touched.FL_TRANS_TYPE && (
                        <div className="error">{errors.FL_TRANS_TYPE}</div>
                      )}
                    </Grid>
                    <Grid item xs={4}>
                      <InputLabel>Transaction Date</InputLabel>
                      <JumboTextField
                        size="small"
                        fullWidth
                        name="FL_TRANS_DATE"
                        type="date"
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <InputLabel>Select Business type</InputLabel>
                      <Field
                        size="small"
                        name="FL_BUSINESS_TYPE"
                        InputLabel="Select Business"
                        as={Select}
                        fullWidth
                      >
                        <MenuItem value="">Select Business</MenuItem>
                        {mdata?.OUR_BUSINESS_TYPE.map((item) => (
                          <MenuItem value={item.FL_GPID}>
                            {item.FL_PARA_VALUE}
                          </MenuItem>
                        ))}
                      </Field>
                      {errors.FL_BUSINESS_TYPE && touched.FL_BUSINESS_TYPE && (
                        <div className="error">{errors.FL_BUSINESS_TYPE}</div>
                      )}
                    </Grid>
                    <Grid item xs={5}>
                      <InputLabel>Select Party</InputLabel>
                      <Field
                        size="small"
                        name="FL_PARTY_CODE"
                        InputLabel="Select Party"
                        as={Select}
                        fullWidth
                      >
                        <MenuItem value="">Select Select Party</MenuItem>
                        {mdata?.VENDOR.map((item) => (
                          <MenuItem value={item.FL_PARTY_CODE}>
                            {item.FL_PARTY_NAME}
                          </MenuItem>
                        ))}
                      </Field>
                      {errors.FL_PARTY_CODE && touched.FL_PARTY_CODE && (
                        <div className="error">{errors.FL_PARTY_CODE}</div>
                      )}
                    </Grid>
                    <Grid item xs={5}>
                      <InputLabel>Select Bank</InputLabel>
                      <Field
                        size="small"
                        name="FL_TO_ACH_CODE"
                        InputLabel="Select Bank"
                        as={Select}
                        fullWidth
                      >
                        <MenuItem value="">Select Select Bank</MenuItem>
                        {mdata?.leadgerdetail?.map((item) => (
                          <MenuItem value={item.ACODE}>{item.ANAME}</MenuItem>
                        ))}
                      </Field>
                      {errors.FL_TO_ACH_CODE && touched.FL_TO_ACH_CODE && (
                        <div className="error">{errors.FL_TO_ACH_CODE}</div>
                      )}
                    </Grid>
                    <Grid item xs={2}>
                      <InputLabel>Select Term</InputLabel>
                      <Field
                        size="small"
                        name="FL_TERM_CODE"
                        InputLabel="Select Term"
                        as={Select}
                        fullWidth
                      >
                        <MenuItem value="">Select Select Term</MenuItem>
                        {mdata?.TERM.map((item) => (
                          <MenuItem value={item.FL_TERM_CODE}>
                            {item.FL_TERM_NAME}
                          </MenuItem>
                        ))}
                      </Field>
                      {errors.FL_TERM_CODE && touched.FL_TERM_CODE && (
                        <div className="error">{errors.FL_TERM_CODE}</div>
                      )}
                    </Grid>
                    <Grid item xs={4}>
                      <InputLabel>Select Ship type</InputLabel>
                      <Field
                        size="small"
                        name="FL_SHIP_BY"
                        InputLabel="Select Ship type"
                        as={Select}
                        fullWidth
                      >
                        <MenuItem value="">Select Select Ship type</MenuItem>
                        {mdata?.SHIPPEDBY.map((item) => (
                          <MenuItem value={item.FL_GPID}>
                            {item.FL_PARA_VALUE}
                          </MenuItem>
                        ))}
                      </Field>
                      {errors.FL_SHIP_BY && touched.FL_SHIP_BY && (
                        <div className="error">{errors.FL_SHIP_BY}</div>
                      )}
                    </Grid>
                    <Grid item xs={4}>
                      <InputLabel>Select Curr type</InputLabel>
                      <Field
                        size="small"
                        name="FL_CURR_CODE"
                        InputLabel="Select Curr"
                        as={Select}
                        fullWidth
                      >
                        <MenuItem value="">Select Curr</MenuItem>
                        {mdata?.CURR.map((item) => (
                          <MenuItem value={item.FL_CURRENCY_ID}>
                            {item.FL_CURRENCY_NAME}
                          </MenuItem>
                        ))}
                      </Field>
                      {errors.FL_CURR_CODE && touched.FL_CURR_CODE && (
                        <div className="error">{errors.FL_CURR_CODE}</div>
                      )}
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <InputLabel>Currency Rate</InputLabel>
                      <JumboTextField
                        size="small"
                        fullWidth
                        name="FL_CONV_RATE"
                        type="text"
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <InputLabel>Select INVENTORY type</InputLabel>
                      <Field
                        size="small"
                        name="FL_DIAMOND_TYPE"
                        InputLabel="Select Diamond"
                        as={Select}
                        fullWidth
                      >
                        <MenuItem value="">Select INVENTORY</MenuItem>
                        {mdata?.INVETORYTYPE.map((item) => (
                          <MenuItem value={item.NAME}>{item.NAME}</MenuItem>
                        ))}
                      </Field>
                      {errors.FL_DIAMOND_TYPE && touched.FL_DIAMOND_TYPE && (
                        <div className="error">{errors.FL_DIAMOND_TYPE}</div>
                      )}
                    </Grid>

                    <Grid item xs={12} sm={5}>
                      <InputLabel>INVOICE Bill no.</InputLabel>
                      <JumboTextField
                        size="small"
                        fullWidth
                        name="FL_BILL_NO"
                        type="text"
                      />
                    </Grid>
                    <Grid item xs={5}>
                      <InputLabel>Select Broker</InputLabel>
                      <Field
                        size="small"
                        name="FL_BROKER_PARTY"
                        InputLabel="Select Broker"
                        as={Select}
                        fullWidth
                      >
                        <MenuItem value="">Select Broker</MenuItem>
                        {mdata?.BROKER.map((item) => (
                          <MenuItem value={item.FL_PARTY_CODE}>
                            {item.FL_PARTY_NAME}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={2}>
                      <InputLabel>Brockrage Rate(%)</InputLabel>
                      <JumboTextField
                        size="small"
                        fullWidth
                        name="FL_BROKER_PER"
                        type="number"
                      />
                    </Grid>
                    <Grid
                      item
                      sx={{ display: "flex", alignItems: "center" }}
                      xs={12}
                      sm={2}
                    >
                      <Field
                        size="small"
                        component={Checkbox}
                        name="FL_ADAT_FLG"
                        label="Currency Rate"
                        onChange={handleChange}
                        fullWidth
                      />

                      <InputLabel>IS On Adat</InputLabel>
                    </Grid>

                    <Grid item xs={9}>
                      <InputLabel>Naration</InputLabel>
                      <TextareaAutosize
                        name="FL_NARRATION"
                        label="Naration"
                        minRows={5}
                        style={{ width: "98%" }}
                        onChange={handleChange}
                        fullWidth
                      >
                        {values.FL_NARRATION || ""}
                      </TextareaAutosize>
                    </Grid>
                    <Grid
                      item
                      sx={{ display: "flex", alignItems: "center" }}
                      justifyContent="end"
                      xs={12}
                      sm={3}
                    >
                      {excelfile != null && (
                        <Button
                          variant="outlined"
                          color="primary"
                          disabled={loading}
                          onClick={handleShowJsonData}
                        >
                          show Excel
                        </Button>
                      )}
                    </Grid>
                    <Grid item xs={12}>
                      {!values?.detlist ? (
                        <ExcelFileUpload
                          onFileUpload={(file) => {
                            setExcelfile(file);
                          }}
                        />
                      ) : (
                        <Paper>
                          <MaterialReactTable table={table} />
                        </Paper>
                      )}
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <LoadingButton
                        variant="contained"
                        color="primary"
                        type="submit"
                        loading={loading}
                        disabled={isSubmitting && excelfile != null}
                      >
                        Submit
                      </LoadingButton>
                    </Grid>
                  </Grid>
                </Form>
              )
            }
          </Formik>
        </CardContent>
      </Card>
      {/* Modal for displaying Excel data */}
      <Dialog fullScreen open={openModal} onClose={handleCloseModal}>
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h1">Excel Data Preview</Typography>
          <Close sx={{ cursor: "pointer" }} onClick={handleCloseModal} />
        </DialogTitle>
        <DialogContent>
          {excelData.length > 0 && (
            <div>
              <Div
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography variant="h4">
                  Total Diamond: {excelData.length} PCS
                </Typography>
                <Typography variant="h4">
                  Total Weight: {totalWeight} CTS{" "}
                </Typography>
              </Div>
              {/* <TableContainer  component={Paper}> */}
              <Table size="small" sx={{ whiteSpace: "nowrap" }}>
                <TableHead>
                  <TableRow>
                    {Object.keys(excelData[0]).map((key) => (
                      <TableCell key={key}>{key}</TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {displayData.map((row, index) => (
                    <TableRow key={index}>
                      {Object.values(row).map((value, valueIndex) => (
                        <TableCell key={valueIndex}>{value}</TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
              {/* </TableContainer> */}

              <TablePagination
                rowsPerPageOptions={rowsPerPageOptions}
                component="div"
                count={excelData.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};
PolishInward.Modulename = "PolishInward";

export default PolishInward;
